const type = 'DECREMENT_SELECTED_RESULT';

const decrementSelectedResult = () => ({
  type,
});

export { type };
export default decrementSelectedResult;
